<script setup lang="ts">
interface IProps {
    small?: boolean;
    desktopSmall?: boolean;
    mobileView?: boolean;
    url: string;
    title: string;
}
const { url, mobileView, small, desktopSmall, title } = defineProps<IProps>();
const alt = computed(() => `لوگوی ${title}`);
const loading = ref(true);
</script>

<template>
    <mr-loading
        v-show="loading"
        class="loading"
        :class="{
            small,
            'desktop-small': desktopSmall,
            'mobile-view': mobileView,
        }"
    />
    <NuxtImg
        v-show="!loading"
        class="logo-image"
        :class="{
            small,
            'desktop-small': desktopSmall,
            'mobile-view': mobileView,
        }"
        :src="url"
        :alt
        v-bind="$attrs"
        @load="loading = false"
    />
</template>

<style lang="scss" scoped>
@mixin mobile-view {
    width: 32px;
    height: 32px;
    &.small {
        width: 28px;
        height: 28px;
    }
    &.desktop-small {
        width: 28px;
        height: 28px;
    }
}

.logo-image,
.loading {
    object-fit: contain;
    width: 40px;
    height: 40px;
    &.mobile-view {
        @include mobile-view();
    }
    @include mobile-only() {
        @include mobile-view();
    }
    &.small {
        width: 36px;
        height: 36px;
    }
    &.desktop-small {
        width: 28px;
        height: 28px;
    }
}
</style>
